export default __webpack_public_path__ + "static/media/partner-header.3c5a80ae.jpg";